export default "__VITE_ASSET__Co4ZJMIv__"